import { useLang } from 'hooks/lang';

import { Column } from 'components/Blocks';

import { InvoiceProjects } from './Projects';
import { Invoices } from './Invoices';
import { ClientBalances } from './ClientBalances';
import { Packages } from './Packages';
import { OutsourceInvoices } from './OutsourceInvoices';

export type Counts = Record<string, number>;

function InvoiceHome(): JSX.Element {
  const { t } = useLang();

  return (
    <Column>
      <h5 className="text-primary">{t('invoice-dashboard')}</h5>

      <InvoiceProjects />

      <Invoices />

      <OutsourceInvoices />

      <ClientBalances />

      <Packages />
    </Column>
  );
}

export default InvoiceHome;
